import { useParams } from "react-router-dom";

//Components
import FinanceClaniceNacrtovanoCardItem from "./FinanceClaniceNacrtovanoCardItem";

//API calls
import { useGetNacrtovaneVrednostiProjektaClanice } from "../../../../services/ProjectDetails/financeAPI";

const FinanceClaniceNacrtovanoCards = () => {
  const { id } = useParams();
  const { data: nacrtovaneVrednostiClanic = [], isLoading } =
    useGetNacrtovaneVrednostiProjektaClanice(id);

  if (isLoading) {
    return (
      <div className="mb-3 mt-3">
        <h6 className="form-section-heading">
          Podatki ki se nanašajo na članice UM
        </h6>
        <p>Nalaganje načrtovanih finančnih podatkov članic...</p>
      </div>
    );
  }

  return (
    <div>
      <h6 className="form-section-heading">
        Podatki ki se nanašajo na članice UM
      </h6>
      {nacrtovaneVrednostiClanic.map((clanica) => (
        <FinanceClaniceNacrtovanoCardItem
          key={clanica.clanicaID}
          clanica={clanica}
        />
      ))}
    </div>
  );
};

export default FinanceClaniceNacrtovanoCards;
